import { render } from "./TextGallery.vue?vue&type=template&id=9eeab81e&scoped=true"
import script from "./TextGallery.vue?vue&type=script&lang=js"
export * from "./TextGallery.vue?vue&type=script&lang=js"

import "./TextGallery.vue?vue&type=style&index=0&id=9eeab81e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9eeab81e"

export default script